import { ImageSource } from 'expo-image';
import { registerImages } from '@bonanza-social/moonlight';

import cashOrBonus from './cash-or-bonus.webp';
import bonanzaPromoCoins from './bonanza-promo-coins.webp';
import bonanzaPromoWheel from './bonanza-promo-wheel.webp';
import fallBackBannerMini from './fallback-banner-mini.webp';

import icons from './icons';

const images = {
  ...icons,

  cashOrBonus,
  bonanzaPromoCoins,
  bonanzaPromoWheel,
  fallBackBannerMini,
};

registerImages('promos', images);

declare global {
  interface RegisteredImages {
    promos: Record<keyof typeof images, ImageSource>;
  }
}
